export enum DocumentType {
  IMAGE = 'Image',
  CONDITION_REPORT = 'Condition report',
  INSTRUCTIONS = 'Installation instructions',
  RESTORATION_GUIDELINES = 'Restoration guidelines',
  EXHIBITION_HISTORY = 'Exhibition history',
  LOAN_HISTORY = 'Loan history',
  INSURANCE = 'Insurance',
  SHIPPING_INFORMATION = 'Shipping information',
  ARTISIT_CV = 'Artist CV',
  ARCHIVE_PHOTOS = 'Archive Photos',
  PRESS = 'Press',
  OTHER = 'Other',
}
